import Footer from 'components/global/footer';
import Home from 'pages/home';
import Inventory from 'pages/inventory';
import Login from 'pages/login';
import Register from 'pages/register';
import SellerDashboard from 'pages/seller';
import SellerOrders from 'pages/seller/orders';
import Cart from 'pages/user/cart';
import UserDashboard from 'pages/user/dashboard';
import MyCompaigns from 'pages/user/myCompaigns';
import NewCompaign from 'pages/user/newCompaign';
import ScreenDetails from 'pages/user/screenDetails';
import SellerScreens from 'pages/user/sellerScreens';
import SellersList from 'pages/user/SellersList';
import Settings from 'pages/user/settings';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router , Routes , Route } from 'react-router-dom';


function App() {
    const { showSidebar } = useSelector(state => state.sidebar)
    return (
        <div>
            <Router>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/inventory' element={<Inventory />} />
                    <Route path='/user/dashboard' element={<UserDashboard />} />
                    <Route path='/user/seller-list' element={<SellersList />} />
                    <Route 
                    path='/user/seller-screens/:sellerId' 
                    element={<SellerScreens />} 
                    />
                    <Route 
                    path='/user/screen-details/:screenId' 
                    element={<ScreenDetails />}
                    /> 
                    <Route 
                    path='/user/cart'
                    element={<Cart />}
                    />
                    <Route 
                    path='/user/compaigns'
                    element={<MyCompaigns />}
                    />
                    <Route 
                    path='/user/new-compaign'
                    element={<NewCompaign />}
                    />
                    <Route 
                    path='/user/settings'
                    element={<Settings />}
                    />
                    <Route 
                    path='/register'
                    element={<Register />}
                    />
                    <Route 
                    path='/login'
                    element={<Login />}
                    />
                    {/* Seller */}
                    <Route 
                    path='/seller'
                    element={<SellerDashboard />}
                    />
                    <Route 
                    path='/seller/dashboard'
                    element={<SellerDashboard />}
                    />
                    <Route
                    path='/seller/orders'
                    element={<SellerOrders />}
                    />

                </Routes>
            </Router>
            {
                showSidebar && <div className='absolute top-0 left-0 bg-[#0000007e] w-full h-screen z-30 md:hidden'></div>
            }
        </div>
    );
}

export default App;
